import { trackAutoEvent } from '../../vendor/splitmetrics-track/index';



export const EVENT_NAME = 'main_gallery_slide_inaction';

export default (intervalParams) => {
  trackAutoEvent(EVENT_NAME, intervalParams, {});
};



// WEBPACK FOOTER //
// ./src/lib/track-event/main-gallery-slide-inaction.js